// Profil tamamlanma yüzdesi — Dashboard ve Profile sayfası tek kaynak kullansın
export const calcProfileProgress = (profile) => {
  if (!profile) return 0;
  const arr = (k) => Array.isArray(profile[k]) ? profile[k] : [];
  const obj = (k) => profile[k] && typeof profile[k] === 'object' ? profile[k] : {};
  const checks = [
    profile.first_name, profile.last_name, profile.phone, profile.city,
    profile.university, profile.department, profile.grade, profile.gpa,
    arr('skills').length > 0,
    arr('certificates').length > 0,
    profile.bio, profile.linkedin_url, profile.github_url,
    arr('work_experiences').length > 0,
    arr('projects').length > 0,
    Object.keys(obj('ctf_platforms')).length > 0,
    profile.cv_file_url,
    arr('languages').length > 0,
  ];
  return Math.round((checks.filter(Boolean).length / checks.length) * 100);
};
